/* ============================================
   CWM MASTERPIECES – Home v3 (cwh-*)
   assets/cwm-home.js
   Needs: GSAP + ScrollTrigger (theme.liquid), Lenis via window.cwmLenis()
   Built by Audax CS
   ============================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGsap = function () { return typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined'; };
  var lenis = function () { return typeof window.cwmLenis === 'function' ? window.cwmLenis() : null; };

  /* ---------- Hero ---------- */
  function initHero(root) {
    if (!hasGsap() || reduce || root.dataset.cwhInit) return;
    root.dataset.cwhInit = '1';
    var media = root.querySelector('[data-cwh-hero-media]');
    var content = root.querySelector('[data-cwh-hero-content]');
    var tl = gsap.timeline({ defaults: { ease: 'expo.out' } });
    if (media) tl.from(media, { scale: 1.14, duration: 2.8, ease: 'power3.out' }, 0);
    tl.from(root.querySelectorAll('.cwh-line > span'), { yPercent: 110, duration: 1.6, stagger: 0.14 }, 0.35)
      .from(root.querySelectorAll('[data-cwh-fade]'), { opacity: 0, y: 16, duration: 1.2, stagger: 0.12 }, 1.0);
    if (media) gsap.to(media, { yPercent: 18, ease: 'none', scrollTrigger: { trigger: root, start: 'top top', end: 'bottom top', scrub: true } });
    if (content) gsap.to(content, { opacity: 0, y: -40, ease: 'none', scrollTrigger: { trigger: root, start: '30% top', end: '75% top', scrub: true } });
  }

  /* ---------- Statement ---------- */
  function initStatement(root) {
    if (!hasGsap() || reduce || root.dataset.cwhInit) return;
    root.dataset.cwhInit = '1';
    var p = root.querySelector('[data-cwh-statement]');
    if (!p) return;
    p.innerHTML = p.textContent.trim().split(/\s+/).map(function (w) { return '<span class="cwh-w">' + w + '</span>'; }).join(' ');
    root.classList.add('is-ready');
    gsap.to(p.querySelectorAll('.cwh-w'), { opacity: 1, stagger: 0.12, ease: 'none',
      scrollTrigger: { trigger: root, start: 'top 70%', end: 'center 45%', scrub: true } });
  }

  /* ---------- Reveal (pinned sequence) ---------- */
  function initReveal(root) {
    if (!hasGsap() || reduce || root.dataset.cwhInit) return;
    var stage = root.querySelector('[data-cwh-stage]');
    var imgs = gsap.utils.toArray(root.querySelectorAll('[data-cwh-reveal-img]'));
    var steps = gsap.utils.toArray(root.querySelectorAll('.cwh-step'));
    var items = gsap.utils.toArray(root.querySelectorAll('.cwh-reveal__index li'));
    var bar = root.querySelector('.cwh-reveal__bar');
    if (!stage || imgs.length < 2 || imgs.length !== steps.length) return;
    root.dataset.cwhInit = '1';
    root.classList.add('is-live');

    gsap.set(imgs.slice(1), { clipPath: 'circle(0% at 50% 50%)' });
    gsap.set(steps.slice(1), { yPercent: 40, opacity: 0 });

    var tl = gsap.timeline({
      defaults: { ease: 'power2.inOut' },
      scrollTrigger: {
        trigger: stage, start: 'top top', end: '+=' + (imgs.length * 80) + '%', pin: true, scrub: 1,
        onUpdate: function (self) {
          var idx = Math.min(items.length - 1, Math.floor(self.progress * items.length));
          items.forEach(function (li, i) { li.classList.toggle('is-active', i === idx); });
        }
      }
    });
    tl.to({}, { duration: 0.35 });
    for (var i = 1; i < imgs.length; i++) {
      var at = tl.duration();
      tl.fromTo(imgs[i], { clipPath: 'circle(0% at 50% 50%)', scale: 1.08 }, { clipPath: 'circle(72% at 50% 50%)', scale: 1, duration: 1 }, at)
        .to(imgs[i - 1], { scale: 0.94, duration: 1 }, at)
        .to(steps[i - 1], { yPercent: -40, opacity: 0, duration: 0.5 }, at)
        .to(steps[i], { yPercent: 0, opacity: 1, duration: 0.5 }, at + 0.45)
        .to({}, { duration: 0.45 });
    }
    if (bar) tl.fromTo(bar, { scaleY: 0 }, { scaleY: 1, ease: 'none', duration: tl.duration() }, 0);
  }

  /* ---------- Image reveals + parallax ---------- */
  function initFigures(scope) {
    if (!hasGsap() || reduce) return;
    scope.querySelectorAll('[data-cwh-reveal]:not([data-cwh-init])').forEach(function (el) {
      el.setAttribute('data-cwh-init', '1');
      gsap.fromTo(el, { clipPath: 'inset(12% 8% 12% 8%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.8, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 85%' } });
      var m = el.querySelector('img,video');
      if (m) gsap.fromTo(m, { yPercent: -5, scale: 1.12 }, { yPercent: 5, scale: 1.12, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    scope.querySelectorAll('[data-cwh-parallax]:not([data-cwh-init])').forEach(function (el) {
      el.setAttribute('data-cwh-init', '1');
      var m = el.querySelector('img,video');
      if (m) gsap.fromTo(m, { yPercent: -8, scale: 1.18 }, { yPercent: 8, scale: 1.18, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
  }

  /* ---------- Floating product image (statement) ---------- */
  function initFloat(scope) {
    if (!hasGsap() || reduce) return;
    scope.querySelectorAll('[data-cwh-float]:not([data-cwh-init])').forEach(function (el) {
      el.setAttribute('data-cwh-init', '1');
      gsap.fromTo(el, { yPercent: 12, rotate: -6 }, { yPercent: -12, rotate: 4, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
  }

  /* ---------- Inline videos: play only while visible ---------- */
  function initVideos(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { var pr = e.target.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else e.target.pause();
      });
    }, { threshold: 0.25 });
    scope.querySelectorAll('video[data-cwh-autoplay]').forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------- Buy module ---------- */
  function money(cents, fmt) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2).replace('.', ',');
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (fmt || 'XAMOUNTX €').replace('XAMOUNTX', s);
  }

  function initBuy(root) {
    if (root.dataset.cwhInit) return;
    root.dataset.cwhInit = '1';
    var form = root.querySelector('[data-cwh-form]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[data-cwh-atc]');
    var btnText = form.querySelector('[data-cwh-atc-text]');
    var priceEl = root.querySelector('[data-cwh-price]');
    var added = root.querySelector('[data-cwh-added]');
    var fmt = root.getAttribute('data-cwh-money') || 'XAMOUNTX €';

    root.querySelectorAll('[data-cwh-variant]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        idInput.value = r.value;
        var available = r.getAttribute('data-available') === 'true';
        btn.disabled = !available;
        btnText.textContent = available ? btn.getAttribute('data-label') : btn.getAttribute('data-label-out');
        if (priceEl) priceEl.textContent = money(parseInt(r.getAttribute('data-price'), 10), fmt);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      btnText.textContent = btn.getAttribute('data-label-busy');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (c) { return c.json(); });
      }).then(function (cart) {
        document.querySelectorAll('.cwm-hd__cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        btnText.textContent = btn.getAttribute('data-label-done');
        if (added) added.classList.add('is-on');
        setTimeout(function () { btn.disabled = false; btnText.textContent = btn.getAttribute('data-label'); }, 2400);
      }).catch(function () {
        btn.disabled = false;
        btnText.textContent = btn.getAttribute('data-label-error');
      });
    });

    // Sticky bar
    var sticky = root.querySelector('[data-cwh-sticky]');
    if (sticky) {
      document.body.appendChild(sticky);
      var link = sticky.querySelector('a');
      var start = document.querySelector('.cwh-reveal') || document.querySelector('.cwh-hero');
      var foot = document.querySelector('.cwm-ft') || document.querySelector('footer');
      var update = function () {
        var vh = window.innerHeight;
        var past = start ? start.getBoundingClientRect().bottom < vh * 0.4 : window.scrollY > vh;
        var b = root.getBoundingClientRect();
        var buyVisible = b.top < vh && b.bottom > 0;
        var footVisible = foot ? foot.getBoundingClientRect().top < vh : false;
        var on = past && !buyVisible && !footVisible;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (link) link.tabIndex = on ? 0 : -1;
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      var l = lenis(); if (l && l.on) l.on('scroll', update);
      update();
      if (link) link.addEventListener('click', function (e) {
        var l2 = lenis();
        if (l2) { e.preventDefault(); l2.scrollTo(root, { duration: 1.4 }); }
      });
    }
  }

  /* ---------- Anchor links with Lenis ---------- */
  function initAnchors(scope) {
    scope.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (a.dataset.cwhAnchor) return;
      a.dataset.cwhAnchor = '1';
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        var target = id.length > 1 ? document.querySelector(id) : null;
        var l = lenis();
        if (target && l) { e.preventDefault(); l.scrollTo(target, { duration: 1.6 }); }
      });
    });
  }

  /* ---------- TimeTraveller-Wortmarke (JHC Audemars + ®) ---------- */
  var TT_SKIP = /^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION|SELECT|TITLE|NOSCRIPT|SVG)$/;
  function wrapWordmark(scope) {
    if (!scope || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeValue.indexOf('TimeTraveller') === -1) return NodeFilter.FILTER_REJECT;
        for (var el = n.parentNode; el && el !== scope.parentNode; el = el.parentNode) {
          if (el.nodeType !== 1) continue;
          if (TT_SKIP.test(el.nodeName) || el.classList.contains('cwh-tt') || el.hasAttribute('data-no-tt')) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var parts = node.nodeValue.split(/(TimeTraveller®?)/);
      // alles in EIN Inline-Element packen, damit Flex-Container (Buttons, FAQ-Fragen) den Text nicht zerteilen
      var frag = document.createElement('span');
      frag.className = 'cwh-tt-wrap';
      parts.forEach(function (part) {
        if (/^TimeTraveller®?$/.test(part)) {
          var span = document.createElement('span');
          span.className = 'cwh-tt';
          span.appendChild(document.createTextNode('TimeTraveller'));
          var sup = document.createElement('sup');
          sup.textContent = '®';
          span.appendChild(sup);
          frag.appendChild(span);
        } else if (part) {
          frag.appendChild(document.createTextNode(part));
        }
      });
      var next = node.nextSibling;
      node.parentNode.replaceChild(frag, node);
      // doppeltes ® vermeiden (z. B. TimeTraveller<sup>®</sup>)
      if (next && next.nodeType === 1 && next.nodeName === 'SUP' && next.textContent.trim() === '®') next.parentNode.removeChild(next);
      else if (next && next.nodeType === 3 && next.nodeValue.charAt(0) === '®') next.nodeValue = next.nodeValue.slice(1);
    });
  }

  function initAll(scope) {
    scope = scope || document;
    if (hasGsap()) gsap.registerPlugin(ScrollTrigger);
    scope.querySelectorAll('[data-cwh="hero"]').forEach(initHero);
    scope.querySelectorAll('[data-cwh="statement"]').forEach(initStatement);
    scope.querySelectorAll('[data-cwh="reveal"]').forEach(initReveal);
    scope.querySelectorAll('[data-cwh="buy"]').forEach(initBuy);
    initFigures(scope);
    initFloat(scope);
    initVideos(scope);
    initAnchors(scope);
    wrapWordmark(scope === document ? (document.getElementById('MainContent') || document.body) : scope);
    document.querySelectorAll('.cwh-sticky').forEach(wrapWordmark);
    if (hasGsap()) ScrollTrigger.refresh();
  }

  function boot() {
    initAll(document);
    window.addEventListener('load', function () { if (hasGsap()) ScrollTrigger.refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-init a section after it reloads
  document.addEventListener('shopify:section:load', function (e) {
    if (hasGsap()) ScrollTrigger.getAll().forEach(function (t) { if (e.target.contains(t.trigger)) t.kill(true); });
    initAll(e.target);
  });
})();